

{
  "pages": {
    "Login": {
      "attrs": {
        "singapore": "Malaysia",
        "pomelo": "CIMB",
        "simonverraestsiamtradingth": "ahmad.faisal@bilabila.my"
      },
      "powering_singapores_digital_commerce": "Powering Malaysia's Digital Commerce",
      "the_complete_payment_solution_for_modern": "The complete payment solution for modern merchants. Manage\n              transactions, track settlements, and grow your business with\n              confidence.",
      "merchant_portal": "Merchant Portal",
      "sign_in_to_manage_your_business": "Sign in to manage your business payments",
      "email_address": "Email Address",
      "password": "Password",
      "remember_me": "Remember me",
      "forgot_password": "Forgot password?",
      "sign_in": "Sign In",
      "or": "or",
      "received_an_invitation_code": "Received an invitation code?",
      "dont_have_a_merchant_account": "Don't have a merchant account?",
      "contact_sales": "Contact Sales",
      "back_to_sign_in": "Back to sign in",
      "back": "Back",
      "check_your_email": "Check your email",
      "weve_sent_a_6digit_verification_code": "We've sent a 6-digit verification code to",
      "enter_verification_code": "Enter verification code",
      "verify_sign_in": "Verify & Sign In",
      "didnt_receive_the_code": "Didn't receive the code?",
      "resend_in": "Resend in",
      "s": "s",
      "resend_code": "Resend code",
      "for_your_security_this_code_expires": "For your security, this code expires in 10 minutes. If you\n                    didn't request this code, please secure your account\n                    immediately.",
      "2026_pomelo_pay_all_rights_reserved": "© 2026 CIMB. All rights reserved.",
      "invite_enter_code_title": "Enter your invitation code",
      "invite_enter_code_description": "Use the code from your invitation email to set up your account.",
      "invitation_code": "Invitation code",
      "continue": "Continue",
      "invite_help_text": "Invitation codes are case-insensitive and typically look like BML-A1B2-C3D4. Can't find yours? Check the email from your administrator or contact CIMB support.",
      "invite_code_invalid": "This invitation code is invalid or has expired.",
      "invite_setup_title": "Set up your account",
      "invite_setup_description": "Confirm your details and create a password to complete onboarding.",
      "first_name": "First name",
      "last_name": "Last name",
      "create_password": "Create password",
      "password_requirements": "Use at least 8 characters with a mix of letters, numbers, and symbols.",
      "email_locked_from_invitation": "This email was pre-filled from your invitation and can't be changed here.",
      "create_account": "Create account"
    }
  }
}

